import React from 'react'
import { BalloonContent } from "./BalloonContent"
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import Confetti from 'react-confetti'


import "./../assets/scss/Balloon.scss";



export const Balloon = (props) => {
  const stars = [];
  for (let i = 0; i < 60; i++) {
    stars.push(<div className="star" key={i}  />);
  }

    return(
      <div>
        <div className="underlay" onClick={() => props.onChangeStep()}></div>

        {((props.type !== "exit") && !(props.type.includes("link"))) &&
          <div className="overlay" onClick={() => props.onChangeStep()}></div>
        }

        {(props.type == "exit" ) &&
          <div className="overlay" onClick={() => props.onChangeRoom()}></div>
        }

        <div className={`balloon ${(props.type)}`}>
          {(props.button == 'close') &&
            <button className="close" onClick={() => props.onChangeStep()}>
              <CommonSvgContent stringToRet="ics" />
            </button>
          }
          {(props.button == 'follow') &&
            <button className="follow" onClick={() => props.onChangeStep()}>
              <CommonSvgContent stringToRet="freccia" />
            </button>
          }

          {(props.type == "intro" ) &&

            <div className="stars">
              {stars}
            </div>
          }
          {/* <div className="mars">
            <ContentLanding stringToRet="mars" />
          </div> */}

          <BalloonContent stringToRet={`${props.clickon}_room${props.room}`} />

          {(props.type == 'exit') &&
            <Confetti />
          }
        </div>

      </div>
    )
}
